<div [style.color]="formControlErrors ? 'red' : hintColor" class="hint" [ngClass]="{ 'hint-animate': hintMessage }">
  {{ hintMessage }}
</div>
